<template lang="pug">
div
  v-progress-linear(v-if='loading' indeterminate color='#18bedf')
  v-alert(v-else-if='loadError' type='error' dense text) {{ loadError }}
  template(v-else)
    v-checkbox.mt-0(v-model='form.enabled' :label=`$t('TENANT_PIPELINE.ENABLE_UPAGENT')` :disabled='busy' color='#18bedf' hide-details @change='emitStatus')
    .mt-3(v-if='state.codes.length')
      .mb-1(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('TENANT_PIPELINE.ACTIVATION_CODE')}}
      .d-flex.align-center(v-for='code in state.codes' :key='code')
        code.mr-2(style='font-size: 15px;') {{ code }}
        v-btn(icon small @click='copyCode(code)' :title=`$t('TENANT_PIPELINE.COPY')`)
          v-icon(size='16') mdi-content-copy
      .mt-1(style='font-size: 12px; color:#888888;') SSO：{{ state.sso_enabled ? 'ADFS' : '-' }}
    v-alert.mt-2(v-if='initial.enabled && !form.enabled' type='warning' dense text) {{$t('TENANT_PIPELINE.UPAGENT_DISABLE_HINT')}}
    div.mt-4(v-show='form.enabled')
      model-list-editor(:key='editorKey' :source='state.models' :busy='busy' @input='onModelsInput' @valid='onModelsValid')
</template>

<script>
import Vue from "vue";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";
import modelListEditor from "@/components/TenantCenter/Pipeline/pipelineModelListEditor";
import { errorText, snapshot } from "@/components/TenantCenter/Pipeline/pipelineUtils";

export default Vue.extend({
  props: {
    tenant: { type: Object, require: true },
    busy: { type: Boolean, default: false },
  },
  components: {
    modelListEditor,
  },
  data() {
    return {
      loading: true,
      loadError: '',
      state: null,
      initial: { enabled: false },
      form: { enabled: false },
      models: null,
      modelsBaseline: null,
      modelsValid: false,
      editorKey: 0,
    };
  },
  async created() {
    try {
      const response = await TenantCenterService.pipelineGetStage(this.tenant.schema_name, 'upagent');
      this.applyState(response.data);
    } catch (error) {
      this.loadError = errorText(error);
    } finally {
      this.loading = false;
      this.emitStatus();
    }
  },
  methods: {
    applyState(state) {
      this.state = state;
      this.initial = { enabled: state.enabled };
      this.form = { enabled: state.enabled };
      this.modelsBaseline = null;
      this.editorKey += 1;
    },
    onModelsInput(val) {
      this.models = val;
      if (this.modelsBaseline === null) {
        this.modelsBaseline = snapshot(val);
      }
      this.emitStatus();
    },
    onModelsValid(val) {
      this.modelsValid = val;
      this.emitStatus();
    },
    isDirty() {
      if (this.form.enabled !== this.initial.enabled) {
        return true;
      }
      return this.form.enabled && snapshot(this.models) !== this.modelsBaseline;
    },
    emitStatus() {
      this.$nextTick(() => {
        if (this.loading || this.loadError) {
          this.$emit('status', { dirty: false, ready: !this.loading });
          return;
        }
        const dirty = this.isDirty();
        this.$emit('status', { dirty: dirty, ready: !dirty || !this.form.enabled || this.modelsValid });
      });
    },
    copyCode(code) {
      navigator.clipboard.writeText(code);
    },
    async submit() {
      this.$emit('progress', i18n.t('TENANT_PIPELINE.UPDATING'));
      try {
        const response = await TenantCenterService.pipelineUpdateStage(this.tenant.schema_name, 'upagent', {
          enabled: this.form.enabled,
          models: this.models,
        });
        this.applyState(response.data);
      } catch (error) {
        throw new Error(errorText(error));
      } finally {
        this.emitStatus();
      }
    },
  },
});
</script>
